/**
 * Input Schema of ResponsavelConfigWhatsapp
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelConfigWhatsapp} from '@/model/resource/ResponsavelConfigWhatsapp'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {StatusSmsCollection} from '@/model/collection/StatusSmsCollection'
import {TipoOcorrenciaCollection} from '@/model/collection/TipoOcorrenciaCollection'

/* TODO: review generated schema */
export class InputResponsavelConfigWhatsappSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()
  collectionStatusSms = new StatusSmsCollection().noPagination()
  collectionTipoOcorrencia = new TipoOcorrenciaCollection().noPagination()

  readonly name = 'InputResponsavelConfigWhatsapp'

  readonly fieldSet: FieldSet<ResponsavelConfigWhatsapp> = {
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    status: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionStatusSms.all(),
      },
    }),
    whatsappStatus: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    ocorrencia: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionTipoOcorrencia.all(),
      },
    }),
    mensagem: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    templateId: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
